export const DISAGREE_API_MESSAGES = {
  ALREADY_REGISTERED: 'Você já enviou um questionamento para esta questão.',
  SUCCESS: 'Feedback registrado com sucesso.',
  ERROR: 'Erro ao enviar feedback. Tente novamente.',
} as const;
